module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_30-c83df1a760d52a3f71f8ad9e8cbef328.png";